import { InjectionToken } from '@angular/core';
import { LatLng } from 'leaflet';

export interface MarkerDetailLabels {
	bodenform?: string;
	humusform?: string;
	stfg?: string;
	bemerkung?: string;
}

export interface MapMarker<T = any> {
	id: string;
	latLng: LatLng;
	data: T;
	label?: string;
	type?: string;
	author?: string;
	date?: Date | string;
	detailLabels?: MarkerDetailLabels;
}

export interface MapMarkerHandler<T> {
	toMapMarker(document: T): MapMarker<T>;
	hasValidCoordinates(document: T): boolean;
}

export const MAP_MARKER_HANDLER = new InjectionToken<MapMarkerHandler<any>>(
	'MAP_MARKER_HANDLER'
);
